module.exports = __webpack_public_path__ + "img/login-left.db919487.png";